
<script>
import {pageMixin} from '../../mixins/pageMixin';
import NoPermissionInfo from '@/components/noPermissionInfo';
import { 
    getConfigTablesInfoApi, getConfigTableFieldsApi, getConfigListApi,
    getConfigOptionsListApi, editConfigListItemApi, addConfigListItemApi
} from '@/api'
import ConfigForm from './configForm.vue'
import ConfigTable from './configTable.vue'
import _ from 'lodash';
import { addSqlDataModal } from '../modal'
import { STATE_TYPE, INPUT_TYPE } from './constant'
import Vue from 'vue'
export default {
    name: "ConfigPage",
    mixins: [ pageMixin ],
    components: {},
    data() {
        return {
            sqlTableList: [],//数据库表
            formData: {
                t_id: ''
            },
            tabelColumnList: [],
            editColId: '',
            loading: false,
            tabelList: [],
            resetDom: null,
            tabel_key: '',
            optionsMap: new Map(),
        }
    },

    render(h) {
        if (!this.isPageAllowed) {
            return h(NoPermissionInfo)
        };
        const _this =  this;
        const pageFuncNames = _this.pageFuncNames;

        const nodes = [];
        nodes.push(h(ConfigForm, {
            props: {
                t_list: this.sqlTableList,
                formData: this.formData
            },
            on: {
                'update:formData'(value) {
                    _this.formData = value;
                },
                'search-click'() {
                    _this.getTabelData()
                }
            }
        }));
        if (this.tabelColumnList.length) {
            const colNodes = this.tabelColumnList.map((v, i, list)=> {
                return  h("ElTableColumn", {
                    props: {
                        prop: v.field_name,
                        'min-width': '240px'
                    },
                    scopedSlots: {
                        header:()=> {
                            return [
                                v.show_name, 
                                
                                (v.edit_disable === STATE_TYPE.ENABLE&&pageFuncNames.includes('edit_config'))?h('i', { class:'el-icon-edit' }):'',
                                v.title? h('ElTooltip', {
                                    props: {
                                        effect: 'dark',
                                        content: v.title,
                                        placement: 'top'
                                    },
                                }, [h('i', { class:'el-icon-question' })]):''
                            ]
                        },
                        default: (props)=> {
                            const field_name = v.field_name;
                            const label = v.type === INPUT_TYPE.SELECT ? props.row[field_name]?.name : props.row[field_name]
                            return h('div', {
                                on: {
                                    dblclick: async (e)=> {
                                        if (v.edit_disable === STATE_TYPE.ENABLE && pageFuncNames.includes('edit_config')) {
                                            const callback = (isEdit, data)=> {
                                                 const target = e.target;
                                                if (isEdit) {
                                                    if (typeof data === 'object') {
                                                        target.textContent = data.label || '--';
                                                        props.row[field_name] = {
                                                            name: data.label,
                                                            id: data.value
                                                        };
                                                    }else {
                                                        target.textContent = data || '--';
                                                        props.row[field_name] = data;
                                                    }
                                                };
                                                
                                                dom.replaceWith(target);
                                                _this.resetDom = null;
                                            };
                                            const params = { 
                                                props: props, column: v,
                                                value: props.row[field_name],
                                                callback
                                            }
                                            if (v.type === INPUT_TYPE.SELECT) {
                                                const optionsList = await _this.handleDblclick(v,props,list);
                                                params.list = optionsList
                                            } 
                                            const dom =  _this.getCustomCom({ 
                                               ...params
                                            });
                                            e.target.replaceWith(dom);
                                            
                                            if (_this.resetDom) {
                                                _this.resetDom()
                                            };
                                            _this.resetDom = callback;
                                        }
                                    }
                                }
                            },  [ label || '--']);
                        }
                    }
                })
            })
             nodes.push(h(ConfigTable, {
                key: this.tabel_key,
                props: {
                    tip: this.tabelTip,
                    list: _this.tabelList,
                    hasAdd: pageFuncNames.includes('add_config'),
                    
                },
                on: {
                    'add-click': ()=> {
                        _this.handleAddClick()
                    }
                },
                scopedSlots: {
                    default: (props)=> {
                        return  colNodes;
                    }
                }
            }));
        }else {
            nodes.push(h('div', { class:'no-tabel text-gray' }, '暂无数据或者选择配置表查询'))
        }
        return h('div', { 
                class:'content-box',
                directives: [
                    {
                        name:'loading',
                        value: _this.loading
                    }
                ] 
            }, nodes)
    },
    created() {
         this.getConfigTablesInfo()
    },
    computed: {
        tabelTip() {
            const data = this.sqlTableList.find(v=>v.table_id === this.formData.t_id);
            if (data) {
                return data.used_modules
            }
            return ''
        }
    },
    methods: {
        async handleDblclick(col, props, list) {
            try {
                const { id, table_id,field_name ,required } = col;
                const params = {
                    table_id,
                    field_id: id,
                };
                const key = JSON.stringify(params);
                if (this.optionsMap.has(key)) {
                    return this.optionsMap.get(key)
                }
                const row = props.row;
                if (required) {
                    const fieldIdName = list.reduce((pre, item)=> {
                        pre[item.id] = item.field_name;
                        return pre;
                    }, {})
                    const param = required.split(',').reduce((pre,id)=> {
                        const key = fieldIdName[id];
                        pre[key] = row[key]
                        return pre;
                    }, {});
                    Object.assign(params, param);
                };
                
               const {data} = await getConfigOptionsListApi(params);
               this.optionsMap.set(key, data)
               return data
            } catch (error) {
                console.log('获取下拉框失败', error);
                this.$message.error(error.info || error.message);
                return Promise.reject(error)
            }
        },
        getCustomCom({ props, column, callback, value, list = [] }) {
           
            const __this = this;
            const node = {
                data() {
                    return {
                        editValue: null,
                    }
                },
                render(h) {
                    const _this = this;
                    const nodes = [];
                    let component = null;
                    const attrs = {
                        props: {
                            value: this.editValue
                        },
                        on: {
                            input: (value)=> {
                                _this.editValue  = value;
                            }
                        },
                    };
                    let saveData = ()=>{};
                    switch (column.type) {
                        case 'select':
                            const options = list || [];
                            const nodes =options.map(option=> {
                                return h('ElOption', {
                                    props: {
                                        value: option.id,
                                        label: option.name
                                    }
                                })
                            });
                            component = h('ElSelect', _.merge(attrs, {
                                scopedSlots: {
                                    default:()=> {
                                        return nodes;
                                    }
                                }
                            }));
                            saveData = ()=> {
                                const data = options.find(v=> v.id ===  _this.editValue);
                                return {
                                    value: data?.id,
                                    label: data?.name
                                }
                            }
                            break;
                        case 'text':
                            component = h('ElInput', _.merge(attrs, {}));
                            saveData = ()=> {
                                return _this.editValue;
                            }
                            break;
                        default:
                            break;
                    };
                    nodes.push(component);
                    nodes.push(h('ElButton', {
                        props: {
                            type: 'primary',
                            icon: 'el-icon-check',
                            circle: true
                        },
                        on: {
                            click: async ()=> {
                                const row = props.row;
                                // if (!_this.editValue) {
                                //     this.$message.error('当前修改内容为空') ;
                                //     return;
                                // }
                                // 数据验证
                                if (column.validate_frontend&&_this.editValue) {
                                    const test = new RegExp(column.validate_frontend);
                                    if (!test.test(_this.editValue)) {
                                        this.$message.error(column.validate_msg);
                                        return
                                    }
                                }
                                await __this.saveEditData();
                                const data = saveData();
                                if (column.edit_required === STATE_TYPE.DISABLE) {
                                    let hasData = true;
                                    if (typeof data === 'object') {
                                        hasData = !!data.value
                                    }else {
                                        hasData = !!data
                                    }
                                    if (!hasData) {
                                      this.$message.error('此项必填') ;
                                      return;
                                    }
                                };
                                try {
                                    __this.loading = true;
                                    const params = {
                                        table_id: __this.formData.t_id,
                                        id: row.id,
                                        [column.field_name]: _this.editValue
                                    };
                                    await editConfigListItemApi(params);
                                    callback(true, data)
                                } catch (error) {
                                    this.$message.error(error.info || error.message)
                                }finally {
                                    __this.loading = false
                                }
                            }
                        }
                    }))
                    nodes.push(h('ElButton', {
                        props: {
                            type: 'danger',
                            icon: 'el-icon-close',
                            circle: true
                        },
                        on: {
                            click: ()=> {
                                callback(false)
                            }
                        }
                    }))
                    return h('div', { class: 'edit-tabel', style: { 'display': 'flex' } }, nodes)
                }
            };
            const InstanceNode = Vue.extend({
                extends: node,
                data(){
                    console.log(value, 'valuevalue');
                    return {
                        editValue: __this.isObject(value)?value.id:value
                    }
                }
            });
            const instance = new InstanceNode();
            instance.$mount();
            return instance.$el;
        },
        saveEditData() {
            return new Promise((resolve, reject)=> {
                 this.$confirm('敏感数据，请谨慎操作，是否保存?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    resolve()
                }).catch(() => {
                    reject()
                    this.editColId = ''
                    this.$message({
                        type: 'info',
                        message: '已取消编辑'
                    });          
                });
            })
           
        },
        // 获取表头和数据
        async getTabelData() {
            const { t_id } = this.formData;
            if (!t_id) {
                this.$message.error('请选择配置表')
                return;
            }
            const params = {
                table_id: t_id
            }
            this.tabel_key = Date.now()
            try {
                this.loading = true;
                 const [ tableFields, configList ] = await Promise.all([
                    getConfigTableFieldsApi(params), 
                    getConfigListApi(params)
                ]);
                this.tabelColumnList = tableFields.data;
                this.tabelList = configList.data;
            } catch (error) {
                console.log('获取表数据错误', error);
                this.$message.error(error.info || error.message)
            } finally {
                this.loading = false;
            }
        },
        // 获取列表数据
        async getList() {
            const { t_id } = this.formData;
            const params = {
                table_id: t_id
            };
            try {
              this.loading = true;
              const { data } = await getConfigListApi(params);
              this.tabelList = data
            } catch (error) {
                console.log('获取列表数据错误', error);
                this.$message.error(error.info || error.message)
            }finally {
                this.loading = false;
            }
        },
        // 获取配置
        async getConfigTablesInfo() {
            try {
                const result = await getConfigTablesInfoApi();
                this.sqlTableList = result.data;
                console.log(result, 222);
            } catch (error) {
                console.log(error, '获取系统配置错误');
                this.$message.error(error.info || error.message)
            }
        },
        handleAddClick() {
            const onSubmit = async (data, cb)=> {
                try {
                     const params = {
                        table_id: this.formData.t_id,
                        ...data
                    };
                    await addConfigListItemApi(params);
                    vm.close();
                    this.getList()
                    this.$message.success('新增成功')
                } catch (error) {
                    console.log('新增错误', error);
                    this.$message.error(error.info || error.message);
                    
                }finally {
                    cb()
                }
            }
            const { vm } = addSqlDataModal({
                props: {
                    list: this.tabelColumnList,
                },
                cbs: {
                    onSubmit
                }
            })
        },
        isObject(value) {
            return Object.prototype.toString.call(value) === '[object Object]'
        }
    }
}
</script>

<style lang="scss" scoped>
.content-box {
    // margin: 0 -10px;
    .no-tabel {
        margin-top: 10px;
        height: 200px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ccc;
    }
    .edit-tabel {
        display: flex;
    }
}
</style>